import { type DesignSystemContext, DesignSystemContextProvider, Direction } from "@drone-js/core";
import { theme as droneAgodaTheme } from "@drone-js/theme-agoda";
import { Routes } from "@generouted/react-router/lazy";
import { addAppInsights } from "libs/analytics/appinsights";
import { createRoot } from "react-dom/client";

import "./app.css";

addAppInsights();

const context: DesignSystemContext = {
    theme: droneAgodaTheme,
    direction: Direction.LTR,
    experiment: {
        /* Add all experiments required by Drone, check with us if you are not sure about the values */
        /* See also https://gitlab.agodadev.io/full-stack/design-system/drone-js/-/wikis/Experiments-and-Feature-Flags */
        isCitiAccessibilityColorUpdate: true,
        cssArchitecture: false,
        gridSizeFallback: true,
        isCitiTokenCorrectionUpdate: false,
        alwaysMountTooltip: false,
        isZoomFontSizeFix: true,
        inputTrailingAssetPaddingFix: true,
        isMigratingNotificationToAccessibleColor: true,
        hideHorizontalScrollFadeOnSmallScreens: true,
        deprecateInaccessibleColor: true,
        isToggleButtonAccessibilityColorFix: true,
    },
};

createRoot(document.getElementById("root")!).render(
    <DesignSystemContextProvider value={context}>
        <Routes />
    </DesignSystemContextProvider>,
);
